// extracted by mini-css-extract-plugin
module.exports =  {"popup-triggers":"_32bbee5fda--popup-triggers--HP7y5","popup-actions":"_32bbee5fda--popup-actions--s9LOC"};